import { render, staticRenderFns } from "./pointEdit.vue?vue&type=template&id=27e34b39&scoped=true&"
import script from "./pointEdit.vue?vue&type=script&lang=ts&"
export * from "./pointEdit.vue?vue&type=script&lang=ts&"
import style0 from "./pointEdit.vue?vue&type=style&index=0&id=27e34b39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e34b39",
  null
  
)

export default component.exports